export enum MarketplaceFilterType
{
    All = 0,
    InApp = 1,
    InStore = 2
}